'use strict';

/*
	DATA SIGNATURE FOR USAGE (with data-attribute) should be as follows.
	Don't forget the quotes around the object keys
	<my-element class='my-super-img' data-focal-point='{ "hasFocal": #myImgData.has_focal#, "height": #myImgData.height#, "width": #myImgData.width#, "x": #myImgData.focal_x_percent#, "y": #myImgData.focal_y_percent# }'></my-element>
*/

// Note: The hasFocal property was created to utilize this module to get a "cover" effect, even if the image didn't have a focal point. We now have a separate obj-fit module for this purpose. Although, this module should still be used for any parallax images because in order to support obj-fit in ie11 we would normaly use a transform fallback to center the image, but that will conflict with the parallax transform.

// Note: This module does not support focal points on images that use object-fit: cover;. Only use object-fit: cover; if your image doesn't have a focal point.

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var domCache = require('dom-cache');
var imageProportion = require('image-proportion');
var throttle = require('lodash/function/throttle');

var parallax = require('./parallax');

var instanceCount = 0;
var windowHeight;
// Only IE11 lacks support
// var browserHasCssSupportsApi = !!(window.CSS && window.CSS.supports);
// If the browser doesn't have window.CSS.supports support, assume IE11, which has support for background-attachment fixed
// var browserHasBgAttachmentFixedSupport = browserHasCssSupportsApi ? window.CSS.supports('background-attachment', 'fixed') : true;

var focalPoint = function(opts) {

	var dom;
	var options;
	var instanceId;
	var pendingResizeRAF = false;
	var parallaxInstance = parallax.create();

	var adjustImage = function($img, data) {

		var hasFocal = data.hasFocal;
		var isBackground = $img.is('img') ? false : true;
		var $container = isBackground ? $img : options.targetContainer ? $img.closest(options.targetContainer) : $img.parent();
		var containerWidth = $container.width() + parseFloat($container.css('padding-left')) + parseFloat($container.css('padding-right'));
		var containerHeight;
		var cover;
		var focal;
		var distanceFromCenter;
		var adjustedOffset;
		var imgCenter;
		var imgLeftOffset;
		var targetAxis;
		var targetDirection;
		var nonTargetDirection;
		var targetDimension;
		var targetOffset;
		var cssObj;

		if (data.isFixedParallax) {

			// Use the viewport as the containing height
			containerHeight = windowHeight;

		} else {

			containerHeight = $container.height() + parseFloat($container.css('padding-top')) + parseFloat($container.css('padding-bottom'));

			if (data.isParallax) {
				containerHeight = parallaxInstance.getContainerHeight(windowHeight, containerHeight, $img);

			}

		}

		cover = imageProportion.cover(data.width, data.height, containerWidth, containerHeight);

		// Determine which axis is overflowing and can be adjusted.
		if (cover.xOverflow) {

			targetAxis = 'x';
			targetDirection = 'left';
			nonTargetDirection = 'top';
			targetDimension = 'width';
			targetOffset = 'xOffset';

		} else {

			targetAxis = 'y';
			targetDirection = 'top';
			nonTargetDirection = 'left';
			targetDimension = 'height';
			targetOffset = 'yOffset';

		}

		// Before we had a separate obj-fit.js system module, this focal point module was used to achieve a cover effect, even for images that didn't actually have a focal point. In order to support a covered and centered image in this scenario, we have to manually size and position the image, regardless of if hasFocal is true.
		if (!isBackground) {

			// Pull the image left or up, in order to center it
			cssObj = {
				width: cover.width,
				height: cover.height,
			};

			cssObj[targetDirection] = cover[targetOffset];

			// Reset the non target direction in case the container size has changed and the non target direction previously was the target direction
			cssObj[nonTargetDirection] = 0;

			$img.css(cssObj);

		}

		$img.attr('data-focal-point-processed', '');

		// Note: for the fixed parallax effect, the image must always have a focal point set via the data attribute, even if the user hasn't explicitly set a focal point, because we need to explicitly size and position the background image
		if (hasFocal) {

			// Determine the scaled location of the focal point.
			focal = data[targetAxis] / 100 * cover[targetDimension];

			// How far from the center is the focal point?
			imgCenter = cover[targetDimension] / 2;

			distanceFromCenter = imgCenter - focal;

			if (Math.abs(distanceFromCenter) > Math.abs(cover[targetOffset])) {

				// Honoring the focal point would adjust the image too much.
				// Determine which direction we are trying to go and make
				// sure the adjustment doesn't leave any whitespace.

				if (distanceFromCenter > 0) {

					// We are trying to push the image too far, don't let it go
					// past the edge.
					adjustedOffset = 0;

				} else {

					// We are trying to pull the image too far, don't let it go
					// past the edge. Adding 1 to deal with browser rounding.
					// It's better to have the focal point be off by 1px than
					// pull the image too far and have a 1px gap in the container.
					adjustedOffset = Math.ceil(cover[targetOffset] * 2) + 1;

				}

			} else {

				// We can honor the focal point.
				adjustedOffset = cover[targetOffset] + distanceFromCenter;

			}

			if (isBackground) {

				if (cover.xOverflow) {

					if (data.isFixedParallax/* && browserHasBgAttachmentFixedSupport*/) {

						// We can't measure the offset if the element is not displayed, so temporarily display it, get the offset, and reset
						if ($img.css('display') === 'none') {

							$img.css({
								visibility: 'hidden',
								display: 'block'
							});

							imgLeftOffset = $img.offset().left;

							$img.css({
								visibility: '',
								display: ''
							});

						} else {

							imgLeftOffset = $img.offset().left;

						}

						$img.css({
							// Set an explicit cover size for our parallax container. We can't use a css cover because the browser will think we are trying to cover the entire viewport, due to the fixed background attachment.
							'background-size': cover.width + 'px ' + cover.height + 'px',
							// Factor in the positioning in the viewport of the parallax container
							'background-position': (imgLeftOffset + adjustedOffset) + 'px 0px'
						});

					} else {

						$img.css({
							// Remove 'fixed' for times when isFixedParallax is true but the browser doesn't support fixed attachments
							// 'background-attachment': 'none',
							'background-position': adjustedOffset + 'px center'
						});

					}

				} else {

					if (data.isFixedParallax/* && browserHasBgAttachmentFixedSupport*/) {

						if ($img.css('display') === 'none') {

							$img.css({
								visibility: 'hidden',
								display: 'block'
							});

							imgLeftOffset = $img.offset().left;

							$img.css({
								visibility: '',
								display: ''
							});

						} else {

							imgLeftOffset = $img.offset().left;

						}

						$img.css({
							// Set an explicit cover size for our parallax container. We can't use a css cover because the browser will think we are trying to cover the entire viewport, due to the fixed background attachment.
							'background-size': cover.width + 'px ' + cover.height + 'px',
							// Factor in the positioning in the viewport of the parallax container
							'background-position': imgLeftOffset + 'px ' + adjustedOffset + 'px'
						});

					} else {

						$img.css({
							// Remove 'fixed' for times when isFixedParallax is true but the browser doesn't support fixed attachments
							// 'background-attachment': 'none',
							'background-position': 'center ' + adjustedOffset + 'px'
						});

					}

				}

			} else {

				$img.css(targetDirection, adjustedOffset);

			}

		}

	};

	// Used on init and window resize
	var adjustAll = function() {

		// Adjust all images
		dom.imgs.each(function(i) {

			var $img = dom.imgs.eq(i);

			adjustImage($img, $img.data(options.dataAttributeName));

		});

	};

	// Used when new items have been added, ie refresh has been called
	var adjustNewImgs = function() {

		// Adjust new images to the dom that have not been processed yet
		dom.imgs.filter(':not([data-focal-point-processed])').each(function() {

			var $img = $(this);
			var data = $img.data(options.dataAttributeName);

			if (data.isParallax) {

				parallaxInstance.add($img);

			}

			adjustImage($img, data);

		});

	};

	var adjust = function() {

		// Don't add another call to requestAnimationFrame to the stack unless the last call we made has already executed
		if (!pendingResizeRAF) {

			pendingResizeRAF = true;

			window.requestAnimationFrame(function() {

				pendingResizeRAF = false;
				windowHeight = domCache.window.height();

				parallaxInstance.refresh();
				adjustAll();

			});

		}

	};

	var setupDom = function() {

		dom = {
			imgs: $(options.target)
		};

	};

	var setupOptions = function(o) {

		options = {
			dataAttributeName: 'focal-point',
			target: '[data-focal-point]',
			targetContainer: '',
			resizeThrottle: 100
		};

		$.extend(options, o || {});

	};

	var addEventHandlers = function() {

		domCache.window
			.off('.focal-point-' + instanceId)
			.on('resize.focal-point-' + instanceId, options.resizeThrottle ? throttle(adjust, options.resizeThrottle) : adjust);

	};

	var init = function() {

		instanceId = instanceCount++;
		setupOptions(opts);
		setupDom();
		addEventHandlers();

		windowHeight = domCache.window.height();

		parallaxInstance.add(dom.imgs.filter(function() {

			return $(this).data(options.dataAttributeName).isParallax;

		}));

		// Apply focal point to all images
		adjustAll();

	};

	// For when new focal point images are added to the DOM
	var refresh = function() {

		setupDom();
		adjustNewImgs();

	};

	// For when the dom is mutated in a way that affects the offset of the parent container
	var refreshParallax = function() {

		parallaxInstance.refresh();

	};

	var destroy = function() {

		domCache.window.off('.focal-point-' + instanceId);
		dom = null;
		options = null;
		instanceId = null;

	};

	init();

	return {
		destroy: destroy,
		adjust: adjust,
		refresh: refresh,
		refreshParallax: refreshParallax
	};

};

module.exports = focalPoint;
